import { useLocation } from 'react-router'
import { parse } from 'qs'

export function useQueryParams() {
  const { search } = useLocation()
  const parsed = parse(search.slice(1))
  return Object.keys(parsed).reduce<Record<string, string | undefined>>(
    (record, key) => {
      const value = parsed[key]
      record[key] = value?.toString()
      return record
    },
    {}
  )
}
